/**
 * Dois desfechos da sessão de estudo: a fila vazia e a leitura que falhou.
 * São telas diferentes de propósito. O pai monta uma delas a partir da fase
 * da sessão. Nenhuma das duas desenha um baralho.
 */
import { revisaoPrimaryActionClass } from "./revisaoSurfaces";

export interface FilaVaziaProps {
  onVoltar: () => void;
}

export function FilaVazia({ onVoltar }: FilaVaziaProps): JSX.Element {
  return (
    <div
      data-sessao-estado="vazia"
      className="flex flex-col items-center gap-3 px-4 py-16 text-center"
    >
      <h2 className="text-xl font-semibold text-ink">Não há cartões nesta sessão</h2>
      <p className="max-w-sm text-sm text-ink-secondary">
        A fila chegou vazia. Volte para montar outra sessão.
      </p>
      <button
        type="button"
        onClick={onVoltar}
        className={`${revisaoPrimaryActionClass} mt-2 w-full sm:w-auto`}
      >
        Voltar à revisão
      </button>
    </div>
  );
}

export interface LeituraFalhouProps {
  onTentarDeNovo: () => void;
}

export function LeituraFalhou({ onTentarDeNovo }: LeituraFalhouProps): JSX.Element {
  return (
    <div
      data-sessao-estado="falhou"
      className="flex flex-col items-center gap-3 px-4 py-16 text-center"
    >
      <h2 className="text-xl font-semibold text-ink">A leitura da fila falhou</h2>
      <p className="max-w-sm text-sm text-ink-secondary">
        Não foi possível carregar os cartões.
      </p>
      <button
        type="button"
        onClick={onTentarDeNovo}
        className="mt-2 w-full rounded-full border border-warn/40 bg-warn/[0.08] px-6 py-2 text-sm font-semibold text-warn-ink hover:bg-warn/[0.14] sm:w-auto"
      >
        Tentar de novo
      </button>
    </div>
  );
}
